import { RatingProps } from './IconProps';

export const FiveStarRating = (props: RatingProps) => {
  const { className, style, rating } = props;

  const validRating = Math.max(0, Math.min(5, rating));

  return (
    <svg
      className={className}
      style={style}
      width="128px"
      height="22px"
      viewBox="0 0 93 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {[...Array(5)].map((_, index) => {
          const fillPercentage =
            Math.min(1, Math.max(0, validRating - index)) * 100;
          return (
            <linearGradient
              id={`grad-${rating}-${index}`}
              key={`grad-${rating}-${index}`}
            >
              <stop offset={`${fillPercentage}%`} stopColor="#FD9400" />
              <stop offset={`${fillPercentage}%`} stopColor="#E0E0E0" />
            </linearGradient>
          );
        })}
      </defs>
      <g fill="#FD9400">
        {[...Array(5)].map((_, index) => (
          <path
            key={`star-${rating}-${index}`}
            d="m8.412 0 2.571 5.305 5.84.806-4.25 4.085L13.61 16l-5.199-2.78L3.212 16l1.038-5.804L0 6.111l5.839-.806z"
            transform={`translate(${index * 18.823})`}
            fill={`url(#grad-${rating}-${index})`} // Use the gradient
          />
        ))}
      </g>
    </svg>
  );
};
